import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { BusinessWebsiteEdit } from "../components/BusinessWebsiteEdit";
import { useBusinessWebsite } from "../hooks/businessWebsiteQueries";

function WebsiteLoader({ businessId, businessName }: { businessId: string; businessName: string }) {
  const query = useBusinessWebsite(businessId);
  if (query.data === undefined) {
    return (
      <Page>
        <PageHeader title="Website" />
        <PageContent>
          {query.error ? <ErrorState title="Couldn't load website" message={query.error.message} onRetry={() => void query.refetch()} /> : <LoadingSpinner message="Loading website..." />}
        </PageContent>
      </Page>
    );
  }
  return <BusinessWebsiteEdit businessId={businessId} businessName={businessName} website={query.data} refreshError={query.error?.message} onRetry={() => void query.refetch()} />;
}

export function BusinessWebsitePage() {
  const { user } = useAuth();
  const { business, businessId, loading } = useCurrentBusiness();
  if (!loading && business && businessId && business.ownerId === user?.id) {
    return <WebsiteLoader key={businessId} businessId={businessId} businessName={business.name} />;
  }
  return (
    <Page>
      <PageHeader title="Website" />
      <PageContent>
        {loading ? <LoadingSpinner message="Loading business..." /> : <ErrorState message={business ? "Only the business owner can manage the website." : "Select a business to manage its website."} />}
      </PageContent>
    </Page>
  );
}
